import { cva, type VariantProps } from 'class-variance-authority';

export const switchVariants = cva(
  'relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent p-0 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:ring-offset-navy-900',
  {
    variants: {
      value: {
        true: 'bg-blue-500',
        false: 'bg-gray-300 dark:bg-white/20',
      },
      disabled: {
        true: 'cursor-not-allowed',
        false: '',
      },
      size: {
        base: 'h-6 w-11',
        small: 'h-4 w-8',
      },
    },
    compoundVariants: [
      {
        disabled: true,
        value: true,
        class: 'bg-blue-200 dark:bg-blue-500/40',
      },
      {
        disabled: true,
        value: false,
        class: 'bg-gray-100 dark:bg-white/10',
      },
    ],
    defaultVariants: {
      disabled: false,
      value: false,
      size: 'base',
    },
  },
);

export type KaSwitchVariants = VariantProps<typeof switchVariants>;
